var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-ad-campaign-create","width":800,"height":"auto","title":"Kampagne erstellen"}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-ad-campaign-form',{attrs:{"projectAdCampaign":_vm.projectAdCampaign,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }